<template>
  <main class="main flex-grow-1">
    <div class="search-result">
      <div class="container pt-15 pb-40">
        <div class="row">
          <div class="col-12">
            <a
              v-if="prevRoute"
              :href="prevRoute.path"
              @click.prevent="goBack"
              class="back d-flex align-items-center mb-15"
            >
              <span class="icon-chevron-primary mr-10"></span>Back to search results
            </a>
            <h1 class="mb-10 mb-md-5">{{item.Name}}</h1>
            <ul class="tag-list d-flex list-unstyled mb-20">
              <li v-for="type in item.Types">
                <a :href="`${search_link}?types[]=${type.name}`">{{type.name}}</a>
              </li>
            </ul>
            <div class="content-holder mb-55">
              <div v-if="item.ImageLarge" class="img-holder float-md-right mb-15 mt-md-10 ml-md-30 mb-md-5">
                  <picture>
                      <source :srcset="item.ImageSmall" media="(max-width: 499px)">
                      <source :srcset="item.ImageMedium" media="(max-width: 1099px)">
                      <source :srcset="item.ImageLarge">
                      <img :src="item.ImageLarge" :alt="item.Name" class="img-fluid w-100">
                  </picture>
              </div>
              <div v-else class="img-holder float-md-right mb-15 mt-md-10 ml-md-30 mb-md-5">
                  <picture>
                      <img style="width:570px;" :src="defaultImage" alt="teipukarea" class="img-fluid w-100">
                  </picture>
              </div>
              <ul class="detail-list list-unstyled  mb-15">
                <li v-if="item.Publisher">
                  <b>Publisher:</b> {{item.Publisher}}
                </li>
                <li>
                  <b>Classification:</b>
                  {{classification}}
                </li>
                <li>
                  <b>Audience:</b>
                  {{targets}}
                </li>
                <li>
                  <b>Language:</b>
                  {{languages}}
                </li>
                <li>
                  <b>Fluency:</b>
                  {{fluency}}
                </li>
              </ul>
              <ul v-show="item.Link" class="detail-list list-unstyled  mb-15">
                <li>
                  <b>Link to this resource:</b> <a :href="item.Link" target="_blank">{{item.Name}}</a>
                </li>
              </ul>
              <div class="download-area mb-15">
                <div v-if="item.IOSLink" class="d-flex align-items-center mb-10">
                  <strong class="title mr-15">IOS download:</strong>
                  <a :href="item.IOSLink" target="_blank">
                    <img
                      src="/_resources/themes/netvalue/images/app-store.svg"
                      alt="App Store"
                      width="120"
                      height="40"
                    />
                  </a>
                </div>
                <div v-if="item.AndroidLink" class="d-flex align-items-center mb-10">
                  <strong class="title mr-15">Android download:</strong>
                  <a :href="item.AndroidLink" target="_blank">
                    <img src="/_resources/themes/netvalue/images/google-play.png" alt="google play" />
                  </a>
                </div>
              </div>
              <span class="font-weight-bold d-block">About this resource:</span>
              <div class="text-holder">
                <p v-html="item.Content"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="row align-self-end">
          <div class="col-12 align-middle">
            <ul class="list-unstyled d-flex justify-content-between">
              <li>
                <a v-if="prevItem" @click.prevent="gotoPrev" class="prev d-flex align-items-center" :href="prevItemURL">
                  <span class="icon-chevron-primary mr-10"></span>Previous resource
                </a>
              </li>
              <li>
                <a v-if="nextItem" @click.prevent="gotoNext" class="next d-flex align-items-center" :href="nextItemURL">
                  Next resource
                  <span class="icon-chevron-primary ml-10"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "ResourcePage",

  props: [],

  data() {
    return {
      item: {},
      prevRoute: null,
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },

  watch: {
    $route(to, from) {
      if (to.params.urlsegment != undefined) {
        this.item = this.resources.find(
          o => o.URLSegment === to.params.urlsegment
        );
      }

    }
  },

  components: {},

  computed: {
    ...mapState(["resources", "search_link", "routeHistory"]),
    prevItem() {
      const currentIndex = this.resources.indexOf(this.item);
      const nextIndex = (currentIndex - 1) % this.resources.length;
      if (this.resources[nextIndex] !== undefined && currentIndex !== nextIndex) {
        return this.resources[nextIndex].URLSegment;
      }
      return '';
    },
    nextItem() {
      const currentIndex = this.resources.indexOf(this.item);
      const nextIndex = (currentIndex + 1) % this.resources.length;
      if (this.resources[nextIndex] !== undefined && nextIndex > 0) {
        return this.resources[nextIndex].URLSegment;
      }
      return '';
    },
    nextItemURL() {
      return `${this.search_link}/show/${this.nextItem}`
    },
    prevItemURL() {
      return `${this.search_link}/show/${this.prevItem}`
    },

    classification() {
      return this.item.Classifications.map(function(elem){return elem.name;}).join(", ")
    },
    targets() {
      return this.item.Targets.map(function(elem){return elem.name;}).join(", ")
    },
    languages() {
      return this.item.Languages.map(function(elem){return elem.name;}).join(", ")
    },
    fluency() {
      return this.item.Fluency.map(function(elem){return elem.name;}).join(", ")
    },
    defaultImage() {
      let img = window.DEFAULT_WEBSITE_IMAGE;
      if (this.item.Types.length > 0) {
        switch (this.item.Types[0].name.toLowerCase()) {
          case 'app':
            img = window.DEFAULT_APP_IMAGE;
            break;

          case 'audio':
            img = window.DEFAULT_AUDIO_IMAGE
            break;

          case 'book':
          case 'ebook':
          case 'e-book':
            img = window.DEFAULT_BOOK_IMAGE
            break;

          case 'video':
            img = window.DEFAULT_VIDEO_IMAGE
            break;

          case 'website':
            img = window.DEFAULT_WEBSITE_IMAGE
            break;

          default:
            img = window.DEFAULT_WEBSITE_IMAGE
            break;
        }
      }

      return img;
    }
  },

  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(this.routeHistory * -1) : this.$router.push("/");
    },
    imageURL(method, width, height){
      return `/thumbnailer/${method}/${this.item.ImageID}/${width}x${height}`
    },
    gotoNext() {
      this.$router.push({ name: 'ResourcePage', params: { urlsegment: this.nextItem } }).then(() => {
        this.$store.commit("incrementRouteHistory");
      })
    },
    gotoPrev() {
      this.$router.push({ name: 'ResourcePage', params: { urlsegment: this.prevItem } }).then(() => {
        this.$store.commit("incrementRouteHistory");
      })
    }
  },

  created() {
    this.item = this.resources.find(
      o => o.URLSegment === this.$route.params.urlsegment
    );

    this.$store.commit("setSelectedResource", this.item);
  },

  mounted() {
    console.log("ResourcePage loaded");
  }
};
</script>
